import GradeCell from './GradeCell';

export default GradeCell;
